import { useState, useContext } from 'react';
import { X_SMALL } from 'lib/DeviceScreen';
import { TINY_RECTANGLE } from 'lib/GoogleAds/Sizes';
import { AdGlobalRefreshContext } from 'contexts/AdGlobalRefreshContext';
import closeButton from 'public/static/images/adhesion-close-button.svg';
import ConditionalRefreshAd from './ConditionalRefreshAd';

interface AdhesionAdProps {
  adhereToBottom?: boolean;
  targeting: number;
}

export default function AdhesionAd({
  adhereToBottom = false,
  targeting,
}: AdhesionAdProps): JSX.Element | null {
  const [isHidden, setIsHidden] = useState(false);
  const { shouldGlobalAdsRefresh } = useContext(AdGlobalRefreshContext);

  if (isHidden) {
    return null;
  }

  return (
    <div className="ad-container">
      <ConditionalRefreshAd
        adConfig={{
          dimensions: [[320, 50]],
          targeting: { inLine: targeting },
          screenSizes: [X_SMALL],
        }}
        placeholderSize={TINY_RECTANGLE}
        shouldRefresh={shouldGlobalAdsRefresh}
      />
      <button aria-label="close" className="close-button" onClick={(): void => setIsHidden(true)} />
      <style jsx>{`
        .ad-container {
          position: fixed;
          z-index: 100;
          top: ${adhereToBottom ? undefined : '0'};
          bottom: ${adhereToBottom ? '0' : undefined};
          display: flex;
          justify-content: center;
          background-color: white;
          width: 100%;
          height: 50px;
        }

        .close-button {
          position: absolute;
          top: ${adhereToBottom ? '-11px' : undefined};
          bottom: ${adhereToBottom ? undefined : '-11px'};
          right: 2px;
          background-color: transparent;
          background-image: url(${closeButton});
          background-size: 24px 24px;
          background-repeat: no-repeat;
          height: 24px;
          width: 24px;
          border: 0;
        }
      `}</style>
    </div>
  );
}
